import React from 'react';
import { Formik } from 'formik';
import { Form as SForm } from 'semantic-ui-react';
import * as Lookups from '../../../Hooks/LookupOptions';
import { PhysicalFeaturesSearchDto } from '@app/api2/api';
import { SEARCH_TYPES_NAMES } from '../../types';
import { PhysicalFeaturesSearchSchema } from './FeaturesForm.Schema';
import SemanticFormikSelect from '@app/components/React/Common/Forms/SemanticFormikSelect';
import SemanticFormikInput from '@app/components/React/Common/Forms/SemanticFormikInput';
import { FormWithButtons } from './FormWithButtons';

interface Props {
  currentParams: PhysicalFeaturesSearchDto;
  setCurrentParams: (p: PhysicalFeaturesSearchDto) => void;
}

export default function FeaturesForm({ currentParams, setCurrentParams }: Props) {
  const { items: FEATURE_TYPE_OPTIONS } = Lookups.useFeatureTypeOptions({ defaultValue: currentParams.featureType });
  const discriminator = SEARCH_TYPES_NAMES.PhysicalFeaturesSearchDto;

  const initialValues: PhysicalFeaturesSearchDto = {
    discriminator,
    operator: currentParams.operator,
    featureType: currentParams.featureType,
    description: currentParams.description || '',
  };

  const handleSubmit = (values: PhysicalFeaturesSearchDto) => {
    setCurrentParams({ ...values, discriminator });
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={PhysicalFeaturesSearchSchema}
      onSubmit={handleSubmit}
      validateOnBlur={false}
      validateOnChange={false}
      enableReinitialize
    >
      {({ handleSubmit }) => (
        <FormWithButtons handleSubmit={handleSubmit}>
          <SForm.Group widths="equal">
            <SemanticFormikSelect
              name="featureType"
              label="Feature Type"
              placeholder="Select type"
              options={FEATURE_TYPE_OPTIONS}
              required
            />
            <SemanticFormikInput
              name="description"
              label="Description"
              placeholder="Enter description"
            />
          </SForm.Group>
        </FormWithButtons>
      )}
    </Formik>
  );
}
